var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartvitals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29153 0.158429C8.18739 -0.00241405 7.9726 -0.0483871 7.81176 0.0557559C7.77067 0.0823578 7.73568 0.117348 7.70908 0.158429C7.51625 0.503352 2.99609 8.63098 2.99609 10.9961C2.99609 13.7597 5.23639 16 7.99996 16C10.7635 16 13.0038 13.7597 13.0038 10.9961C13.0038 8.63098 8.48368 0.503352 8.29153 0.158429Z",
    fill: "#D32F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00037 13.9985C6.34224 13.9985 4.99805 12.6543 4.99805 10.9961C4.99805 10.8119 5.14741 10.6625 5.33165 10.6625C5.51588 10.6625 5.66525 10.8119 5.66525 10.9961C5.66525 12.2858 6.71072 13.3313 8.0004 13.3313C8.18464 13.3313 8.334 13.4807 8.334 13.6649C8.33397 13.8491 8.18461 13.9985 8.00037 13.9985Z",
    fill: "#E57373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartvitals);
export default __webpack_public_path__ + "static/media/smartvitals.69d0f6579c9f4ead0dc6846bcf6e6801.svg";
export { ForwardRef as ReactComponent };